import { handleResponse, handleError } from "./apiUtils";
import { API, graphqlOperation } from 'aws-amplify';
import * as queries from '../graphql/queries';
// import { storedProcParameters } from './apiUtils';
// import util from 'util';

/**
 * Returns an array of resources from the api using the user name and sso.
 * @param {*} name
 * @param {*} sso
 * @param {*} withDisabled
 */
export async function getFindResource(name, sso, withDisabled) {
  let findResource = await API.graphql(graphqlOperation(queries.resourceApIgetResource, { name, sso, withDisabled }));

  return findResource.data.resourceAPIgetResource;
};

export async function getResourcePersonnelData(resourceId) {
  let response = await API.graphql(graphqlOperation(queries.resourceApIgetResourcePersonnelData, { resourceId }));

  return response.data.resourceAPIgetResourcePersonnelData;
};

export async function getResourceByDates(parameters) {

  let response = await API.graphql(graphqlOperation(queries.resourceApIgetResourceByDates, parameters ))
    .catch(handleError);

  return response.data.resourceAPIgetResourceByDates;
}

export async function getResourceContactInfo(parameters) {

  let response = await API.graphql(graphqlOperation(queries.resourceApIgetResourceContactInfo, parameters ))
    .catch(handleError);
  
  return response.data.resourceAPIgetResourceContactInfo;
}



// WEBPACK FOOTER //
// ./src/api/resourceApi.js